import type { Classified } from '@shopgnd/shared';
import { islandListingUrlParishSlug } from '@shopgnd/shared';

export type PropertyPathInput = Pick<Classified, 'id' | 'slug'> & {
  parish?: Classified['parish'] | null;
};

/** Canonical property listing URL (/grenada/carriacou/property/{slug} on dependencies). */
export function propertyPath(c: PropertyPathInput): string {
  const segment = c.slug ?? c.id;
  const island = islandListingUrlParishSlug(c.parish);
  return island
    ? `/grenada/${island}/property/${encodeURIComponent(segment)}`
    : `/grenada/property/${encodeURIComponent(segment)}`;
}
